

































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import ServiceOrderList from '@/pages/Business/ServiceOrder/ServiceOrderList.vue';
import { METHODS } from '@/constants/payment';

@Component({
  components: {
    ServiceOrderList,
  },
  computed: {
    ...mapState('Business', {
      business: 'business',
    }),
  },
})
export default class BusinessUpdateServiceOrder extends Vue {
  business!: Model;
  isMounted = false;
  isLoading = false;
  isInit = false;
  showTopUpDialog = false;
  reload = 0;
  paymentMethods = METHODS;
  showDiscountDialog = false;
  selectedServiceItem!: Model;

  serviceItems: Model[] = [{ object_id: '', current_quantity: 0 }];

  serviceItemTotalAvailableQuantity!: [];

  orderDetails: {
    object_id: string | undefined;
    quantity: number;
    current_quantity: number;
  }[] = [{ object_id: '', quantity: 0, current_quantity: 0 }];

  isApiFetch = {
    isApiFetchServiceItemsFinished: false,
    isApiFetchServiceItemTotalAvailableQuantityFinished: false,
  };

  discountRulesLocal: {
    discount: number;
    unit_price_after_discount: number;
    min_quantity: number;
  }[] = [];

  get discountHeaders() {
    return [
      {
        text: 'Unit Price',
        value: 'unit_price_after_discount',
        sortable: false,
      },
      {
        text: 'Min Quantity to Applied',
        value: 'min_quantity',
        sortable: false,
      },
      { text: '', value: 'action', sortable: false },
    ];
  }

  beforeMount() {
    this.init();
  }

  init() {
    this.isInit = true;
    this.isApiFetch = {
      isApiFetchServiceItemsFinished: false,
      isApiFetchServiceItemTotalAvailableQuantityFinished: false,
    };

    this.$store.commit('ServiceOrder/CLEAR_STATE');
    this.$store.commit('ServicePayment/CLEAR_STATE');

    this.$store
      .dispatch('ServiceItem/fetchList', {
        params: {
          expand: ['discount_rules'],
          business_oid: this.business.object_id,
        },
      })
      .then((response) => {
        this.serviceItems = response.data.data;
        this.isApiFetch['isApiFetchServiceItemsFinished'] = true;
      });

    this.$store
      .dispatch(
        'ServiceItem/serviceItemTotalAvailableQuantity',
        this.business.object_id
      )
      .then((response) => {
        this.serviceItemTotalAvailableQuantity = response.data.data;
        this.isApiFetch[
          'isApiFetchServiceItemTotalAvailableQuantityFinished'
        ] = true;
      });
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (!isFinished) {
        return;
      }

      if (isFinished) {
        for (const [key, value] of Object.entries(this.serviceItems)) {
          this.serviceItems[key]['quantity'] = 0;
          this.serviceItems[key]['current_quantity'] =
            value.object_id &&
            this.serviceItemTotalAvailableQuantity[value.object_id]
              ? parseInt(
                  this.serviceItemTotalAvailableQuantity[value.object_id]
                )
              : 0;
        }

        this.isMounted = true;
        this.isInit = false;
      }
    }
  }

  itemAfterTopUp(i) {
    return (
      Number(this.serviceItems[i].current_quantity) +
      Number(this.serviceItems[i].quantity)
    );
  }

  quantityDecrement(i) {
    this.serviceItems[i].quantity--;
    this.reload++;
  }

  quantityIncrement(i) {
    this.serviceItems[i].quantity++;
    this.reload++;
  }

  topUp() {
    this.isLoading = true;
    const serviceOrder = {
      business_oid: this.business.object_id,
      payment_method: this.paymentMethods.SYSTEM.key,
      order_details: this.serviceItems,
    };
    this.$store.dispatch('ServiceOrder/create', serviceOrder).then(() => {
      this.isLoading = false;
      this.showTopUpDialog = false;
      this.init();
    });
  }

  preventNumberSpecialKeys(event) {
    //., -, +
    if ([43, 45, 46].includes(event.keyCode)) {
      event.preventDefault();
    }
  }

  setUnitPrice(value, i) {
    this.discountRulesLocal[i].unit_price_after_discount = value * 100;
  }

  addRule() {
    this.discountRulesLocal.push({
      discount: 0,
      unit_price_after_discount: this.getUnitPriceByCountry(
        this.selectedServiceItem
      ),
      min_quantity: 0,
    });
  }

  discountRuleForBusiness() {
    this.isLoading = true;
    this.$store
      .dispatch('ServiceItem/discountRuleForBusiness', {
        object_id: this.selectedServiceItem.object_id,
        payload: {
          business_oid: this.business.object_id,
          discount_rules: this.discountRulesLocal,
        },
      })
      .then(() => {
        this.isLoading = false;
        this.showDiscountDialog = false;
        this.init();
      });
  }

  openDiscountDialog(serviceItem) {
    this.selectedServiceItem = serviceItem;
    this.showDiscountDialog = true;
    this.reload++;
    if (serviceItem._discount_rule && !serviceItem._discount_rule.is_default) {
      this.discountRulesLocal = serviceItem._discount_rule.discount_rule.map(
        (rule) => {
          return {
            unit_price_after_discount: Math.round(
              rule.discount * this.getUnitPriceByCountry(serviceItem)
            ),
            min_quantity: rule.min_quantity,
          };
        }
      );
    }
  }

  getUnitPriceByCountry(serviceItem) {
    return (
      serviceItem.unit_price[this.business.country || 'AU'] ||
      serviceItem.unit_price['AU']
    );
  }
}
